import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReportsComponent} from './reports.component';
import {ReportsRoutingModule} from './reports-routing.module';
import {StatsWidget10Component} from './widgets/stats/stats-widget10/stats-widget10.component';
import {InlineSVGModule} from 'ng-inline-svg';
import {NgApexchartsModule} from 'ng-apexcharts';

@NgModule({
    declarations: [
        ReportsComponent,
        // Stats
        StatsWidget10Component,
    ],
    exports: [
        ReportsComponent
    ],
    imports: [
        CommonModule,
        ReportsRoutingModule,
        InlineSVGModule,
        NgApexchartsModule,
    ]
})

export class ReportsModule {

}
